import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class EstadisticasServicioMedicoService {

  constructor(private httpClient:HttpClient) { }

  codigosAmarillos(fechaini, fechafin){
    return this.httpClient.get(`${environment.api }estadisticas-servicio-medico/codAmrillos/${fechaini}/${fechafin}`);
  }

  codigosRojos(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/codRojos/${fechaini}/${fechafin}`);
  }

  codigosVerdes(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/codVerdes/${fechaini}/${fechafin}`);
  }

  totalServiciosDia(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/totalserviciosdia/${fechaini}/${fechafin}`);
  }

  servicioscancelados(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/canceladas/${fechaini}/${fechafin}`);
  }

  servicioscontraslado(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/contraslado/${fechaini}/${fechafin}`);
  }

  sinDespacho(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/sindespacho/${fechaini}/${fechafin}`);
  }

  enProceso(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/enProceso/${fechaini}/${fechafin}`);
  }

  pasadasDetiempo(fechaini, fechafin) {
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/pasadasdetiempo/${fechaini}/${fechafin}`);
  }

  equivocadas(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/equivocadas/${fechaini}/${fechafin}`);
  }

  manuales(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/manuales/${fechaini}/${fechafin}`);
  }

  conlaApp(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/conlaApp/${fechaini}/${fechafin}`);
  }

  trasladoprogramado(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/trasladoprogramado/${fechaini}/${fechafin}`);
  }

  masde100(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/mas/cien/tiempo/${fechaini}/${fechafin}`)
  }


  activos(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/consultasActivas/${fechaini}/${fechafin}`);
  }

  enDespalsamiento(fechaini, fechafin){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/enDespalasamiento/${fechaini}/${fechafin}`);
  }

  conTrasladoActivo(fechaini, fechafin){
      return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/conTrasladoActivo/${fechaini}/${fechafin}`);
  }

  prioridades(){
    return this.httpClient.get(`${environment.api}estadisticas-servicio-medico/prioridades`);
}
}
